export default __webpack_public_path__ + "b88e416e77394fbe9c228954ded49762.svg";